import type { IconData } from '@stacksjs/iconify-core'

export const diamond1Solid: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M11.086 5.5h6.071l-2.863 13H1.343c.094-.42.25-.832.47-1.221l5.354-9.49a4.5 4.5 0 0 1 3.92-2.289m-9.38 16c.212.425.494.822.844 1.172l18.204 18.204L14.413 21.5zm15.863 0L24 41.145L30.43 21.5zm16.017 0l-6.343 19.378L45.45 22.672c.35-.35.633-.747.845-1.172zm13.072-3H33.705l-2.863-13h6.073a4.5 4.5 0 0 1 3.92 2.289l5.353 9.49c.22.39.376.8.47 1.221m-16.025 0H17.366l2.863-13h7.541z\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default diamond1Solid
